import React, { useEffect, useContext } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import { useImmerReducer } from 'use-immer';
import {
    Grid, Snackbar, Typography, Button, TextField,
    Alert, Container, Paper, Box, CircularProgress,
    FormControl, InputLabel, Select, MenuItem, useMediaQuery, useTheme,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
    FormControlLabel, Checkbox, IconButton, Tooltip
} from "@mui/material";
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { useTranslation } from 'react-i18next';
import StateContext from "../../Contexts/StateContext";
import config, { environment } from '../../config';

const defaultIcon = new L.Icon({
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});

function EditThematicPoint() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { category, id } = useParams();
    const GlobalState = useContext(StateContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const initialState = {
        nameValue: '',
        descriptionValue: '',
        birthValue: '',
        deathValue: '',
        worksValue: '',
        informantValue: '',
        collectedByValue: '',
        firstPublicationValue: '',
        selectedEditionValue: '',
        motifMarkerValue: '',
        galleryLinkValue: '',
        hashtagsValue: '',
        collectionYearValue: '',
        drawnByValue: '',
        costumeTypeValue: '',
        isChildValue: false,
        isElderlyValue: false,
        periodValue: '',
        specialNotesValue: '',
        addressValue: '',
        geocodingError: '',
        geocodingSuccess: false,
        builtYearValue: '',
        sketchValue: '',
        wallValue: '',
        floorValue: '',
        roofValue: '',
        economicBuildingsValue: '',
        otherStampsValue: '',
        gateInscriptionValue: '',
        erectedByValue: '',
        erectionYearValue: '',
        woodTypeValue: '',
        isPaintedValue: false,
        isCsangoValue: false,
        latitudeValue: 45.8643,
        longitudeValue: 25.7848,
        // Földtani fields
        regetaniKorValue: '',
        regetaniFormacioValue: '',
        kozetTipusValue: '',
        jellegzetesAsvanyValue: '',
        jellegzetesKovuletValue: '',
        thumbnailFile: null,
        imageFile: null,
        availableImages: [],
        selectedExistingImage: '',
        useExistingImage: false,
        sendRequest: 0,
        openSnack: false,
        disabledBtn: false,
        error: '',
        nameErrors: { hasError: false, errorMessage: '' },
        manualLocationSet: false,
        // Hierarchical selection
        szekOptions: [],
        kozsegOptions: [],
        telepulesOptions: [],
        selectedSzek: '',
        selectedKozseg: '',
        selectedTelepules: '',
    };

    function ourReducer(draft, action) {
        switch (action.type) {
            case 'catchNameChange':
                draft.nameValue = action.value;
                draft.nameErrors.hasError = false;
                draft.nameErrors.errorMessage = '';
                break;
            case 'catchDescriptionChange':
                draft.descriptionValue = action.value;
                break;
            case 'catchBirthChange':
                draft.birthValue = action.value;
                break;
            case 'catchDeathChange':
                draft.deathValue = action.value;
                break;
            case 'catchWorksChange':
                draft.worksValue = action.value;
                break;
            case 'catchInformantChange':
                draft.informantValue = action.value;
                break;
            case 'catchCollectedByChange':
                draft.collectedByValue = action.value;
                break;
            case 'catchFirstPublicationChange':
                draft.firstPublicationValue = action.value;
                break;
            case 'catchSelectedEditionChange':
                draft.selectedEditionValue = action.value;
                break;
            case 'catchMotifMarkerChange':
                draft.motifMarkerValue = action.value;
                break;
            case 'catchGalleryLinkChange':
                draft.galleryLinkValue = action.value;
                break;
            case 'catchHashtagsChange':
                draft.hashtagsValue = action.value;
                break;
            case 'catchCollectionYearChange':
                draft.collectionYearValue = action.value;
                break;
            case 'catchDrawnByChange':
                draft.drawnByValue = action.value;
                break;
            case 'catchCostumeTypeChange':
                draft.costumeTypeValue = action.value;
                break;
            case 'catchIsChildChange':
                draft.isChildValue = action.value;
                break;
            case 'catchIsElderlyChange':
                draft.isElderlyValue = action.value;
                break;
            case 'catchPeriodChange':
                draft.periodValue = action.value;
                break;
            case 'catchSpecialNotesChange':
                draft.specialNotesValue = action.value;
                break;
            case 'catchAddressChange':
                draft.addressValue = action.value;
                draft.geocodingError = '';
                draft.geocodingSuccess = false;
                break;
            case 'setGeocodingError':
                draft.geocodingError = action.value;
                draft.geocodingSuccess = false;
                break;
            case 'setGeocodingSuccess':
                draft.geocodingSuccess = true;
                draft.geocodingError = '';
                break;
            case 'catchBuiltYearChange':
                draft.builtYearValue = action.value;
                break;
            case 'catchSketchChange':
                draft.sketchValue = action.value;
                break;
            case 'catchWallChange':
                draft.wallValue = action.value;
                break;
            case 'catchFloorChange':
                draft.floorValue = action.value;
                break;
            case 'catchRoofChange':
                draft.roofValue = action.value;
                break;
            case 'catchEconomicBuildingsChange':
                draft.economicBuildingsValue = action.value;
                break;
            case 'catchOtherStampsChange':
                draft.otherStampsValue = action.value;
                break;
            case 'catchGateInscriptionChange':
                draft.gateInscriptionValue = action.value;
                break;
            case 'catchErectedByChange':
                draft.erectedByValue = action.value;
                break;
            case 'catchErectionYearChange':
                draft.erectionYearValue = action.value;
                break;
            case 'catchWoodTypeChange':
                draft.woodTypeValue = action.value;
                break;
            case 'catchIsPaintedChange':
                draft.isPaintedValue = action.value;
                break;
            case 'catchRegetaniKorChange':
                draft.regetaniKorValue = action.value;
                break;
            case 'catchRegetaniFormacioChange':
                draft.regetaniFormacioValue = action.value;
                break;
            case 'catchKozetTipusChange':
                draft.kozetTipusValue = action.value;
                break;
            case 'catchJellegzetesAsvanyChange':
                draft.jellegzetesAsvanyValue = action.value;
                break;
            case 'catchJellegzetesKovuletChange':
                draft.jellegzetesKovuletValue = action.value;
                break;
            case 'catchLatitudeChange':
                draft.latitudeValue = action.value;
                break;
            case 'catchLongitudeChange':
                draft.longitudeValue = action.value;
                break;
            case 'catchThumbnailChange':
                draft.thumbnailFile = action.value;
                break;
            case 'catchImageChange':
                draft.imageFile = action.value;
                break;
            case 'catchAvailableImages':
                draft.availableImages = action.value;
                break;
            case 'catchSelectedExistingImage':
                draft.selectedExistingImage = action.value;
                break;
            case 'toggleUseExistingImage':
                draft.useExistingImage = action.value;
                break;
            case 'changeSendRequest':
                draft.sendRequest++;
                break;
            case 'openTheSnack':
                draft.openSnack = true;
                break;
            case 'disableTheBtn':
                draft.disabledBtn = true;
                break;
            case 'enableTheBtn':
                draft.disabledBtn = false;
                break;
            case 'catchNameErrors':
                draft.nameErrors.hasError = true;
                draft.nameErrors.errorMessage = action.value;
                break;
            case 'setError':
                draft.error = action.value;
                break;
            case 'setSzekOptions':
                draft.szekOptions = action.value;
                break;
            case 'setKozsegOptions':
                draft.kozsegOptions = action.value;
                break;
            case 'setTelepulesOptions':
                draft.telepulesOptions = action.value;
                break;
            case 'catchIsCsangoChange':
                draft.isCsangoValue = action.value;
                draft.selectedSzek = '';
                draft.selectedKozseg = '';
                draft.selectedTelepules = '';
                draft.szekOptions = [];
                draft.kozsegOptions = [];
                draft.telepulesOptions = [];
                break;
            case 'setSelectedSzek':
                draft.selectedSzek = action.value;
                draft.selectedKozseg = '';
                draft.selectedTelepules = '';
                draft.kozsegOptions = [];
                draft.telepulesOptions = [];
                break;
            case 'setSelectedKozseg':
                draft.selectedKozseg = action.value;
                draft.selectedTelepules = '';
                draft.telepulesOptions = [];
                break;
            case 'setSelectedTelepules':
                draft.selectedTelepules = action.value;
                if (action.value) {
                    draft.manualLocationSet = true;
                }
                break;
            case 'setManualLocationSet':
                draft.manualLocationSet = action.value;
                break;
            case 'loadData':
                const props = action.value.properties || action.value;
                draft.nameValue = props.name || '';
                draft.descriptionValue = props.description || '';
                draft.birthValue = props.birth || props.szuletett || '';
                draft.deathValue = props.death || props.elhunyt || '';
                draft.worksValue = props.works || props.muvei || '';
                draft.informantValue = props.informant || '';
                draft.collectedByValue = props.collected_by || '';
                draft.firstPublicationValue = props.first_publication || '';
                draft.selectedEditionValue = props.selected_edition || '';
                draft.motifMarkerValue = props.motif_marker || '';
                draft.collectionYearValue = props.collection_year || '';
                draft.drawnByValue = props.drawn_by || '';
                draft.costumeTypeValue = props.costume_type || '';
                draft.isChildValue = props.is_child || false;
                draft.isElderlyValue = props.is_elderly || false;
                draft.periodValue = props.period || '';
                draft.specialNotesValue = props.special_notes || '';
                draft.addressValue = props.address || '';
                draft.builtYearValue = props.built_year || '';
                draft.sketchValue = props.sketch || '';
                draft.wallValue = props.wall || '';
                draft.floorValue = props.floor || '';
                draft.roofValue = props.roof || '';
                draft.economicBuildingsValue = props.economic_buildings || '';
                draft.otherStampsValue = props.other_stamps || '';
                draft.gateInscriptionValue = props.gate_inscription || '';
                draft.erectedByValue = props.erected_by || '';
                draft.erectionYearValue = props.erection_year || '';
                draft.woodTypeValue = props.wood_type || '';
                draft.isPaintedValue = props.is_painted || false;
                draft.isCsangoValue = props.is_csango || false;
                draft.regetaniKorValue = props.stratigraphic_age || '';
                draft.regetaniFormacioValue = props.stratigraphic_formation || '';
                draft.kozetTipusValue = props.rock_type || '';
                draft.jellegzetesAsvanyValue = props.characteristic_mineral || '';
                draft.jellegzetesKovuletValue = props.characteristic_fossil || '';
                draft.galleryLinkValue = props.gallery_link || '';
                draft.hashtagsValue = props.hashtags || '';
                if (action.value.geometry && action.value.geometry.coordinates) {
                    draft.longitudeValue = action.value.geometry.coordinates[0];
                    draft.latitudeValue = action.value.geometry.coordinates[1];
                }
                // Hierarchical location values
                draft.selectedSzek = props.szek || '';
                draft.selectedKozseg = props.kozsegvaros || '';
                draft.selectedTelepules = props.telepules || '';

                if (props.image && props.image.startsWith('Assets/')) {
                    draft.useExistingImage = true;
                    // Extract filename from path
                    const parts = props.image.split('/');
                    if (parts.length > 0) {
                        draft.selectedExistingImage = parts[parts.length - 1];
                    }
                }
                break;
            default:
                break;
        }
    }

    const [state, dispatch] = useImmerReducer(ourReducer, initialState);
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

    function handleGetLocation() {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    dispatch({ type: 'catchLatitudeChange', value: position.coords.latitude });
                    dispatch({ type: 'catchLongitudeChange', value: position.coords.longitude });
                },
                (error) => {
                    console.error("Error getting location:", error);
                    dispatch({ type: 'setError', value: t('Thematic.LocationError', 'Hiba történt a helymeghatározás során.') });
                },
                { enableHighAccuracy: true }
            );
        } else {
            dispatch({ type: 'setError', value: t('Thematic.GeolocationNotSupported', 'A böngésző nem támogatja a helymeghatározást.') });
        }
    }

    const handleDelete = async () => {
        const token = GlobalState.jwtAccessToken || localStorage.getItem('token');
        if (!token) return;

        try {
            await Axios.delete(`${config[environment].apiEndpoint}api/thematic-maps/points/${category}/${id}/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            navigate(-1);
        } catch (e) {
            console.error("Error deleting point:", e);
            dispatch({ type: 'setError', value: t('Common.ErrorDeleting', 'Hiba történt a törlés során.') });
        }
    };

    useEffect(() => {
        async function fetchData() {
            if (!id || id === 'undefined') {
                dispatch({ type: 'setError', value: t('Common.ErrorLoadingData', 'Hiba történt az adatok betöltésekor.') + " (Invalid ID)" });
                return;
            }
            const url = `${config[environment].apiEndpoint}api/thematic-maps/points/${category}/${id}/`;
            
            try {
                const response = await Axios.get(url);
                dispatch({ type: 'loadData', value: response.data });
            } catch (e) {
                dispatch({ type: 'setError', value: t('Common.ErrorLoadingData', 'Hiba történt az adatok betöltésekor.') });
            }
        }
        if (category && id) {
            fetchData();
        }
    }, [id, category, dispatch, t]);

    useEffect(() => {
        async function fetchSzekek() {
            try {
                const response = await Axios.get(`${config[environment].apiEndpoint}api/szek/`);
                const szekData = Array.isArray(response.data) ? response.data : (response.data.results || []);
                dispatch({ type: 'setSzekOptions', value: szekData });
            } catch (e) { console.error("Error fetching szekek:", e); }
        }
        fetchSzekek();
    }, [dispatch]);

    useEffect(() => {
        if (state.isCsangoValue) {
            async function fetchCsangoKozsegek() {
                try {
                    const response = await Axios.get(`${config[environment].apiEndpoint}api/csango-telepules/kozsegek/`);
                    const data = Array.isArray(response.data) ? response.data : [];
                    const sortedData = data.sort((a, b) => a.localeCompare(b));
                    dispatch({ type: 'setKozsegOptions', value: sortedData.map(k => ({ nev: k })) });
                } catch (e) {
                    console.error("Error fetching csango kozsegek:", e);
                }
            }
            fetchCsangoKozsegek();
        }
    }, [state.isCsangoValue, dispatch]);

    useEffect(() => {
        if (state.selectedSzek && !state.isCsangoValue) {
            async function fetchKozsegek() {
                try {
                    let url;
                    // For non-Csango, try to get ID from szekOptions if selectedSzek is a name
                    let szekId = state.selectedSzek;
                    if (state.szekOptions.length > 0) {
                        const szekObj = state.szekOptions.find(s => s.nev === state.selectedSzek || s.name === state.selectedSzek || String(s.id) === String(state.selectedSzek) || String(s.uniqueid) === String(state.selectedSzek));
                        if (szekObj) {
                            szekId = szekObj.id || szekObj.uniqueid || szekObj.pk;
                        }
                    }

                    if (szekId) {
                        try {
                            url = `${config[environment].apiEndpoint}api/kozsegvaros-dropdown/?szek=${encodeURIComponent(szekId)}`;
                            const response = await Axios.get(url);
                            const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
                            if (data.length > 0) {
                                dispatch({ type: 'setKozsegOptions', value: data });
                                return;
                            }
                        } catch (e) {
                            console.warn("Fetch by ID failed, falling back to name...", e);
                        }

                        const isNumeric = /^\d+$/.test(String(szekId));
                        if (!isNumeric || szekId !== state.selectedSzek) {
                            try {
                                url = `${config[environment].apiEndpoint}api/kozsegvaros-dropdown/?szek_nev=${encodeURIComponent(state.selectedSzek)}`;
                                const response = await Axios.get(url);
                                const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
                                if (data.length > 0) {
                                    dispatch({ type: 'setKozsegOptions', value: data });
                                    return;
                                }

                                url = `${config[environment].apiEndpoint}api/kozsegvaros-dropdown/?szek=${encodeURIComponent(state.selectedSzek)}`;
                                const response2 = await Axios.get(url);
                                const data2 = Array.isArray(response2.data) ? response2.data : (response2.data.results || []);
                                dispatch({ type: 'setKozsegOptions', value: data2 });
                            } catch (e) {
                                console.error("Error fetching kozsegek by name:", e);
                            }
                        }
                    }
                } catch (e) { console.error("Error fetching kozsegek:", e); }
            }
            fetchKozsegek();
        }
    }, [state.selectedSzek, dispatch, state.szekOptions]);

    useEffect(() => {
        if (state.selectedKozseg) {
            async function fetchTelepulesek() {
                try {
                    let url;
                    if (state.isCsangoValue) {
                        url = `${config[environment].apiEndpoint}api/csango-telepules/?kozseg=${encodeURIComponent(state.selectedKozseg)}`;
                        const response = await Axios.get(url);
                        const sortedData = [...response.data].sort((a, b) => (a.nev || '').localeCompare(b.nev || ''));
                        dispatch({ type: 'setTelepulesOptions', value: sortedData });
                        return;
                    }
                    // Find selected kozseg object to get reghuid
                    let selectedKozsegObj = null;
                    if (state.kozsegOptions.length > 0) {
                        selectedKozsegObj = state.kozsegOptions.find(k => (k.nev === state.selectedKozseg || k.name === state.selectedKozseg || k.uniqueid === state.selectedKozseg || String(k.id) === String(state.selectedKozseg)));
                    }

                    if (selectedKozsegObj && selectedKozsegObj.reghuid) {
                        url = `${config[environment].apiEndpoint}api/telepules-dropdown/?reghuid=${selectedKozsegObj.reghuid}`;
                        const response = await Axios.get(url);
                        const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
                        dispatch({ type: 'setTelepulesOptions', value: data });
                    } else if (state.selectedKozseg) {
                        // Fallback if reghuid is not available
                        const isId = /^\d+$/.test(String(state.selectedKozseg));
                        if (isId) {
                            url = `${config[environment].apiEndpoint}api/telepules-dropdown/?kozseg=${state.selectedKozseg}`;
                        } else {
                            const endpoints = [
                                `${config[environment].apiEndpoint}api/telepules-dropdown/?kozseg_nev=${encodeURIComponent(state.selectedKozseg)}`,
                                `${config[environment].apiEndpoint}api/telepules-dropdown/?kozsegvaros__nev=${encodeURIComponent(state.selectedKozseg)}`,
                                `${config[environment].apiEndpoint}api/telepules-dropdown/?szek=${encodeURIComponent(state.selectedSzek)}&kozseg=${encodeURIComponent(state.selectedKozseg)}`,
                                `${config[environment].apiEndpoint}api/telepules-dropdown/?szek_nev=${encodeURIComponent(state.selectedSzek)}&kozseg_nev=${encodeURIComponent(state.selectedKozseg)}`,
                                `${config[environment].apiEndpoint}api/telepules/?kozsegvaros__nev=${encodeURIComponent(state.selectedKozseg)}`
                            ];

                            for (const ep of endpoints) {
                                try {
                                    const response = await Axios.get(ep);
                                    const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
                                    if (data.length > 0) {
                                        dispatch({ type: 'setTelepulesOptions', value: data });
                                        return;
                                    }
                                } catch (e) { /* continue */ }
                            }
                            return;
                        }
                        const response = await Axios.get(url);
                        const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
                        dispatch({ type: 'setTelepulesOptions', value: data });
                    }
                } catch (e) { console.error("Error fetching telepulesek:", e); }
            }
            fetchTelepulesek();
        }
    }, [state.selectedKozseg, state.kozsegOptions, dispatch, state.isCsangoValue, state.selectedSzek]);

    useEffect(() => {
        if (state.selectedTelepules && state.manualLocationSet) {
            async function fetchCentroid() {
                try {
                    let url;
                    const selectedTelepulesObj = state.telepulesOptions.find(t => 
                        String(t.id) === String(state.selectedTelepules) || 
                        String(t.uniqueid) === String(state.selectedTelepules) || 
                        String(t.pk) === String(state.selectedTelepules) ||
                        (t.nev_hu === state.selectedTelepules) ||
                        (t.nev === state.selectedTelepules) ||
                        (t.name === state.selectedTelepules)
                    );

                    if (state.isCsangoValue) {
                        if (selectedTelepulesObj && selectedTelepulesObj.geom) {
                            if (selectedTelepulesObj.geom.type === 'Point') {
                                dispatch({ type: 'catchLatitudeChange', value: selectedTelepulesObj.geom.coordinates[1] });
                                dispatch({ type: 'catchLongitudeChange', value: selectedTelepulesObj.geom.coordinates[0] });
                                dispatch({ type: 'setManualLocationSet', value: false });
                                return;
                            }
                        }
                        url = `${config[environment].apiEndpoint}api/csango-telepules/${state.selectedTelepules}/centroid/`;
                    } else {
                        // Use ID if found in telepulesOptions for Szekler settlements too
                        if (selectedTelepulesObj && (selectedTelepulesObj.id || selectedTelepulesObj.uniqueid || selectedTelepulesObj.pk)) {
                            const tId = selectedTelepulesObj.id || selectedTelepulesObj.uniqueid || selectedTelepulesObj.pk;
                            url = `${config[environment].apiEndpoint}api/telepules/${tId}/centroid/`;
                        } else {
                            url = `${config[environment].apiEndpoint}api/telepules/${encodeURIComponent(state.selectedTelepules)}/centroid/`;
                        }
                    }
                    const response = await Axios.get(url);
                    dispatch({ type: 'catchLatitudeChange', value: response.data.latitude });
                    dispatch({ type: 'catchLongitudeChange', value: response.data.longitude });
                } catch (e) { 
                    console.error("Error fetching centroid:", e); 
                } finally {
                    dispatch({ type: 'setManualLocationSet', value: false });
                }
            }
            fetchCentroid();
        }
    }, [state.selectedTelepules, dispatch, state.manualLocationSet, state.isCsangoValue, state.telepulesOptions]);

    useEffect(() => {
        async function fetchAvailableImages() {
            const token = GlobalState.jwtAccessToken || localStorage.getItem('token');
            
            if (!token) {
                return;
            }
            
            try {
                const url = `${config[environment].apiEndpoint}api/thematic-maps/available-images/?category=${category}`;
                const response = await Axios.get(url, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                dispatch({ type: 'catchAvailableImages', value: response.data.images });
            } catch (e) {
                // Silently handle error or add user-facing alert
            }
        }
        fetchAvailableImages();
    }, [category, GlobalState.jwtAccessToken, dispatch]);

    function TheMapComponent() {
        const map = useMap();
        useEffect(() => {
            L.DomUtil.addClass(map.getContainer(), 'crosshair-cursor-enabled');
            const style = document.createElement('style');
            style.innerHTML = '.crosshair-cursor-enabled { cursor: crosshair !important; }';
            document.head.appendChild(style);

            map.on('click', function (e) {
                dispatch({ type: 'catchLatitudeChange', value: e.latlng.lat });
                dispatch({ type: 'catchLongitudeChange', value: e.latlng.lng });
                dispatch({ type: 'setManualLocationSet', value: false });
            });

            return () => {
                L.DomUtil.removeClass(map.getContainer(), 'crosshair-cursor-enabled');
                document.head.removeChild(style);
            };
        }, [map]);
        return null;
    }

    function MapFlyTo({ location }) {
        const map = useMap();
        useEffect(() => {
            if (location[0] && location[1]) {
                map.flyTo(location, 13);
            }
        }, [location, map]);
        return null;
    }

    const getTitle = () => {
        switch (category) {
            case 'nepviselet': return t('Thematic.FolkCostume', 'Népviselet');
            case 'nepi_epiteszet': return t('Thematic.FolkArchitecture', 'Népi építészet');
            case 'szekelykapu': return t('Thematic.Szekelykapu', 'Székelykapu');
            case 'panteon': return t('Thematic.Pantheon', 'Panteon');
            case 'futuristique': return t('Thematic.Futuristique', 'Futuristique');
            case 'ballada': return t('Thematic.Ballada', 'Ballada');
            case 'nepdal': return t('Thematic.Nepdal', 'Népdal');
            case 'locsoloversek': return t('Thematic.Locsoloversek', 'Locsolóversek');
            default: return t('Header.ThematicMaps', 'Tematikus térkép');
        }
    };

    const handleGeocode = async () => {
        if (!state.addressValue) return;
        try {
            const response = await Axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(state.addressValue)}`);
            if (response.data && response.data.length > 0) {
                const { lat, lon } = response.data[0];
                dispatch({ type: 'catchLatitudeChange', value: parseFloat(lat) });
                dispatch({ type: 'catchLongitudeChange', value: parseFloat(lon) });
                dispatch({ type: 'setGeocodingSuccess' });
            } else {
                dispatch({ type: 'setGeocodingError', value: t('Thematic.GeocodingNoResult', 'Nem található koordináta a megadott címhez.') });
            }
        } catch (e) {
            console.error("Geocoding error:", e);
            dispatch({ type: 'setGeocodingError', value: t('Thematic.GeocodingError', 'Hiba történt a keresés során.') });
        }
    };

    function FormSubmit(e) {
        e.preventDefault();
        if (!state.nameValue) {
            dispatch({ type: 'catchNameErrors', value: t('Validation.EmptyName', 'A név megadása kötelező!') });
            return;
        }
        dispatch({ type: 'changeSendRequest' });
        dispatch({ type: 'disableTheBtn' });
    }

    useEffect(() => {
        if (state.sendRequest) {
            async function SubmitFunc() {
                const token = GlobalState.jwtAccessToken || localStorage.getItem('token');
                if (!token) {
                    dispatch({ type: 'setError', value: t('Administration.LoginRequired', 'A folytatáshoz be kell jelentkeznie.') });
                    dispatch({ type: 'enableTheBtn' });
                    return;
                }
                
                const formData = new FormData();
                formData.append('name', state.nameValue);
                formData.append('description', state.descriptionValue);
                formData.append('birth', state.birthValue);
                formData.append('death', state.deathValue);
                formData.append('works', state.worksValue);
                formData.append('informant', state.informantValue);
                formData.append('collected_by', state.collectedByValue);
                formData.append('first_publication', state.firstPublicationValue);
                formData.append('selected_edition', state.selectedEditionValue);
                formData.append('motif_marker', state.motifMarkerValue);
                formData.append('collection_year', state.collectionYearValue);
                formData.append('drawn_by', state.drawnByValue);
                formData.append('costume_type', state.costumeTypeValue);
                formData.append('is_child', state.isChildValue);
                formData.append('is_elderly', state.isElderlyValue);
                formData.append('period', state.periodValue);
                formData.append('special_notes', state.specialNotesValue);
                formData.append('address', state.addressValue);
                formData.append('built_year', state.builtYearValue);
                formData.append('sketch', state.sketchValue);
                formData.append('wall', state.wallValue);
                formData.append('floor', state.floorValue);
                formData.append('roof', state.roofValue);
                formData.append('economic_buildings', state.economicBuildingsValue);
                formData.append('other_stamps', state.otherStampsValue);
                formData.append('gate_inscription', state.gateInscriptionValue);
                formData.append('erected_by', state.erectedByValue);
                formData.append('erection_year', state.erectionYearValue);
                formData.append('wood_type', state.woodTypeValue);
                formData.append('is_painted', state.isPaintedValue);
                formData.append('gallery_link', state.galleryLinkValue);
                formData.append('hashtags', state.hashtagsValue);
                formData.append('category', category);
                formData.append('geom', `POINT(${state.longitudeValue} ${state.latitudeValue})`);
                
                // Földtani fields
                formData.append('stratigraphic_age', state.regetaniKorValue);
                formData.append('stratigraphic_formation', state.regetaniFormacioValue);
                formData.append('rock_type', state.kozetTipusValue);
                formData.append('characteristic_mineral', state.jellegzetesAsvanyValue);
                formData.append('characteristic_fossil', state.jellegzetesKovuletValue);

                // Hierarchical location
                if (state.selectedSzek) formData.append('szek', state.selectedSzek);
                if (state.selectedKozseg) formData.append('kozsegvaros', state.selectedKozseg);
                if (state.selectedTelepules) formData.append('telepules', state.selectedTelepules);
                
                if (state.useExistingImage && state.selectedExistingImage) {
                    formData.append('existing_image', state.selectedExistingImage);
                } else {
                    if (state.thumbnailFile) formData.append('thumbnail', state.thumbnailFile);
                    if (state.imageFile) formData.append('image', state.imageFile);
                }


                try {
                    const tokenForHeader = GlobalState.jwtAccessToken || localStorage.getItem('token');
                    const url = `${config[environment].apiEndpoint}api/thematic-maps/points/${category}/${id}/`;

                    const response = await Axios.patch(url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${tokenForHeader}`,
                            'Accept': 'application/json'
                        }
                    });
                    dispatch({ type: 'openTheSnack' });
                } catch (e) {
                    if (e.response && e.response.status === 401) {
                    }
                    dispatch({ type: 'enableTheBtn' });
                    dispatch({ type: 'setError', value: e.response?.status === 401 ? t('Administration.LoginRequired', 'A folytatáshoz be kell jelentkeznie (lejárt munkamenet).') : t('Common.Error', 'Hiba történt a mentés során.') });
                }
            }
            SubmitFunc();
        }
    }, [state.sendRequest, GlobalState.jwtAccessToken, category, dispatch, id, state.addressValue, state.birthValue, state.builtYearValue, state.collectedByValue, state.collectionYearValue, state.costumeTypeValue, state.deathValue, state.descriptionValue, state.drawnByValue, state.economicBuildingsValue, state.erectedByValue, state.erectionYearValue, state.firstPublicationValue, state.floorValue, state.galleryLinkValue, state.gateInscriptionValue, state.hashtagsValue, state.imageFile, state.informantValue, state.isChildValue, state.isElderlyValue, state.isPaintedValue, state.latitudeValue, state.longitudeValue, state.motifMarkerValue, state.nameValue, state.otherStampsValue, state.periodValue, state.roofValue, state.selectedEditionValue, state.selectedExistingImage, state.selectedKozseg, state.selectedSzek, state.selectedTelepules, state.sketchValue, state.specialNotesValue, state.thumbnailFile, state.useExistingImage, state.wallValue, state.woodTypeValue, state.worksValue, t]);

    useEffect(() => {
        if (state.openSnack) {
            setTimeout(() => {
                navigate(-1);
            }, 1500);
        }
    }, [state.openSnack, navigate]);

    if (!GlobalState.userIsLogged) {
        return (
            <Container maxWidth="sm" sx={{ py: 8 }}>
                <Alert severity="warning">
                    {t('Administration.LoginRequired', 'A folytatáshoz be kell jelentkeznie.')}
                </Alert>
                <Button variant="contained" onClick={() => navigate('/login')} sx={{ mt: 2 }}>
                    {t('Administration.LoginButton')}
                </Button>
            </Container>
        );
    }

    return (
        <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, sm: 2 }, mt: '50px' }}>
            <Paper sx={{ p: { xs: 2, md: 4 } }}>
                <Typography variant={isMobile ? "h5" : "h4"} gutterBottom sx={{ color: '#105b79', fontWeight: 'bold' }}>
                    {getTitle()} +
                </Typography>
                
                <form onSubmit={FormSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={t('Common.Name', 'Név / Megnevezés')}
                                value={state.nameValue}
                                onChange={(e) => dispatch({ type: 'catchNameChange', value: e.target.value })}
                                error={state.nameErrors.hasError}
                                helperText={state.nameErrors.errorMessage}
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                minRows={['ballada', 'nepdal', 'locsoloversek'].includes(category) ? (isMobile ? 6 : 8) : (isMobile ? 3 : 4)}
                                label={category === 'ballada' ? t('Thematic.BalladText') :
                                       category === 'nepdal' ? t('Thematic.FolkSongText') :
                                       category === 'locsoloversek' ? t('Thematic.EasterVerseText') :
                                       t('Common.Description')}
                                value={state.descriptionValue}
                                onChange={(e) => dispatch({ type: 'catchDescriptionChange', value: e.target.value })}
                            />
                        </Grid>

                        {category === 'panteon' && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Birth', 'Született')}
                                        value={state.birthValue}
                                        onChange={(e) => dispatch({ type: 'catchBirthChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Death', 'Elhunyt')}
                                        value={state.deathValue}
                                        onChange={(e) => dispatch({ type: 'catchDeathChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={10}
                                        label={t('Thematic.Works', 'Művei')}
                                        value={state.worksValue}
                                        onChange={(e) => dispatch({ type: 'catchWorksChange', value: e.target.value })}
                                    />
                                </Grid>
                            </>
                        )}

                        {category === 'nepviselet' && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="h6" sx={{ color: '#105b79', fontWeight: 'bold', mt: 2, mb: 1 }}>
                                        {t('Thematic.FolkCostumeDetails', 'Népviselet részletei')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CollectionYear', 'Gyűjtés éve')}
                                        value={state.collectionYearValue}
                                        onChange={(e) => dispatch({ type: 'catchCollectionYearChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CollectedBy', 'Gyűjtő neve')}
                                        value={state.collectedByValue}
                                        onChange={(e) => dispatch({ type: 'catchCollectedByChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.DrawnBy', 'Rajzolta')}
                                        value={state.drawnByValue}
                                        onChange={(e) => dispatch({ type: 'catchDrawnByChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>{t('Thematic.CostumeType', 'Viselet típusa')}</InputLabel>
                                        <Select
                                            value={state.costumeTypeValue}
                                            label={t('Thematic.CostumeType', 'Viselet típusa')}
                                            onChange={(e) => dispatch({ type: 'catchCostumeTypeChange', value: e.target.value })}
                                        >
                                            <MenuItem value="férfi">{t('Thematic.Male', 'Férfi')}</MenuItem>
                                            <MenuItem value="női">{t('Thematic.Female', 'Női')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.isChildValue}
                                                onChange={(e) => dispatch({ type: 'catchIsChildChange', value: e.target.checked })}
                                            />
                                        }
                                        label={t('Thematic.IsChild', 'Gyermek/ fiatal')}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.isElderlyValue}
                                                onChange={(e) => dispatch({ type: 'catchIsElderlyChange', value: e.target.checked })}
                                            />
                                        }
                                        label={t('Thematic.IsElderly', 'Idős viselet')}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Period', 'Viselet időszaka (pl. böjti, házasságkötés)')}
                                        value={state.periodValue}
                                        onChange={(e) => dispatch({ type: 'catchPeriodChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={4}
                                        label={t('Thematic.SpecialNotes', 'Speciális')}
                                        value={state.specialNotesValue}
                                        onChange={(e) => dispatch({ type: 'catchSpecialNotesChange', value: e.target.value })}
                                    />
                                </Grid>
                            </>
                        )}

                        {category === 'nepi_epiteszet' && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="h6" sx={{ color: '#105b79', fontWeight: 'bold', mt: 2, mb: 1 }}>
                                        {t('Thematic.FolkArchitectureDetails', 'Népi építészet részletei')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <TextField
                                        fullWidth
                                        label={t('Common.Address')}
                                        value={state.addressValue}
                                        onChange={(e) => dispatch({ type: 'catchAddressChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        onClick={handleGeocode}
                                        sx={{ height: '56px' }}
                                    >
                                        {t('Thematic.Geocode')}
                                    </Button>
                                </Grid>
                                {state.geocodingError && (
                                    <Grid item xs={12}>
                                        <Alert severity="error" sx={{ mt: 1 }}>
                                            {state.geocodingError}
                                        </Alert>
                                    </Grid>
                                )}
                                {state.geocodingSuccess && (
                                    <Grid item xs={12}>
                                        <Alert severity="success" sx={{ mt: 1 }}>
                                            {t('Thematic.GeocodingSuccess')}
                                        </Alert>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.BuiltYear', 'Épült (évszám)')}
                                        value={state.builtYearValue}
                                        onChange={(e) => dispatch({ type: 'catchBuiltYearChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CollectedBy', 'Gyűjtötte')}
                                        value={state.collectedByValue}
                                        onChange={(e) => dispatch({ type: 'catchCollectedByChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Sketch', 'Vázlatrajz')}
                                        value={state.sketchValue}
                                        onChange={(e) => dispatch({ type: 'catchSketchChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Wall', 'Falazat')}
                                        value={state.wallValue}
                                        onChange={(e) => dispatch({ type: 'catchWallChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Floor', 'Födém')}
                                        value={state.floorValue}
                                        onChange={(e) => dispatch({ type: 'catchFloorChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Roof', 'Héjazat')}
                                        value={state.roofValue}
                                        onChange={(e) => dispatch({ type: 'catchRoofChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        label={t('Thematic.EconomicBuildings', 'Gazdasági épületek')}
                                        value={state.economicBuildingsValue}
                                        onChange={(e) => dispatch({ type: 'catchEconomicBuildingsChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        label={t('Thematic.OtherStamps', 'Egyéb bélyegek')}
                                        value={state.otherStampsValue}
                                        onChange={(e) => dispatch({ type: 'catchOtherStampsChange', value: e.target.value })}
                                    />
                                </Grid>
                            </>
                        )}

                        {(category === 'ballada' || category === 'nepdal' || category === 'locsoloversek') && (
                            <>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.MotifMarker', 'Motívumjelölő')}
                                        value={state.motifMarkerValue}
                                        onChange={(e) => dispatch({ type: 'catchMotifMarkerChange', value: e.target.value })}
                                        helperText={t('Thematic.MotifMarkerHelper', 'Gyakorlatilag az alcím, pl. Pendzsóka (A jávorfa-muzsika)')}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Informant', 'Adatközlő')}
                                        value={state.informantValue}
                                        onChange={(e) => dispatch({ type: 'catchInformantChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CollectedBy', 'Gyűjtötte')}
                                        value={state.collectedByValue}
                                        onChange={(e) => dispatch({ type: 'catchCollectedByChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.FirstPublication', 'Első közlés')}
                                        value={state.firstPublicationValue}
                                        onChange={(e) => dispatch({ type: 'catchFirstPublicationChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={3}
                                        label={t('Thematic.SelectedEdition', 'Válogatott kiadás')}
                                        value={state.selectedEditionValue}
                                        onChange={(e) => dispatch({ type: 'catchSelectedEditionChange', value: e.target.value })}
                                    />
                                </Grid>
                            </>
                        )}

                        {category === 'szekelykapu' && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="h6" sx={{ color: '#105b79', fontWeight: 'bold', mt: 2, mb: 1 }}>
                                        {t('Thematic.SzekelykapuDetails', 'Székelykapu részletei')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={3}
                                        label={t('Thematic.GateInscription', 'Kapufelirat')}
                                        value={state.gateInscriptionValue}
                                        onChange={(e) => dispatch({ type: 'catchGateInscriptionChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.ErectedBy', 'Állíttatta')}
                                        value={state.erectedByValue}
                                        onChange={(e) => dispatch({ type: 'catchErectedByChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.ErectionYear', 'A kapuállítás éve')}
                                        value={state.erectionYearValue}
                                        onChange={(e) => dispatch({ type: 'catchErectionYearChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.WoodType', 'A fa fajtája')}
                                        value={state.woodTypeValue}
                                        onChange={(e) => dispatch({ type: 'catchWoodTypeChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.isPaintedValue}
                                                onChange={(e) => dispatch({ type: 'catchIsPaintedChange', value: e.target.checked })}
                                            />
                                        }
                                        label={t('Thematic.IsPainted', 'Festett')}
                                    />
                                </Grid>
                            </>
                        )}

                        {category === 'foldtani' && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="h6" sx={{ color: '#105b79', fontWeight: 'bold', mt: 2, mb: 1 }}>
                                        {t('Thematic.FoldtaniFeltarasok', 'Földtani feltárások')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.StratigraphicAge')}
                                        value={state.regetaniKorValue}
                                        onChange={(e) => dispatch({ type: 'catchRegetaniKorChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.StratigraphicFormation')}
                                        value={state.regetaniFormacioValue}
                                        onChange={(e) => dispatch({ type: 'catchRegetaniFormacioChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.RockType')}
                                        value={state.kozetTipusValue}
                                        onChange={(e) => dispatch({ type: 'catchKozetTipusChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CharacteristicMineral')}
                                        value={state.jellegzetesAsvanyValue}
                                        onChange={(e) => dispatch({ type: 'catchJellegzetesAsvanyChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CharacteristicFossil')}
                                        value={state.jellegzetesKovuletValue}
                                        onChange={(e) => dispatch({ type: 'catchJellegzetesKovuletChange', value: e.target.value })}
                                    />
                                </Grid>
                            </>
                        )}

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={t('Thematic.GalleryLink', 'Galéria link')}
                                value={state.galleryLinkValue}
                                onChange={(e) => dispatch({ type: 'catchGalleryLinkChange', value: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={t('Thematic.Hashtags', 'Hashtagek')}
                                placeholder="#jovo, #fejlesztes"
                                helperText={t('Thematic.HashtagsHelper', 'Vesszővel elválasztott hashtagek')}
                                value={state.hashtagsValue}
                                onChange={(e) => dispatch({ type: 'catchHashtagsChange', value: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6" gutterBottom>
                                {t('Common.Location')}
                            </Typography>
                            {category === 'foldtani' && (
                                <Alert severity="info" sx={{ mb: 2 }}>
                                    {t('Thematic.ClickToPlacePin', 'Kattintson a térképre a feltárás pontos helyének megjelöléséhez!')}
                                </Alert>
                            )}
                            {category !== 'foldtani' && (
                                <Grid container spacing={2} sx={{ mb: 2 }}>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('Map.Toolbox.szek', 'Szék')}</InputLabel>
                                            <Select
                                                value={state.selectedSzek}
                                                label={t('Map.Toolbox.szek', 'Szék')}
                                                onChange={(e) => dispatch({ type: 'setSelectedSzek', value: e.target.value })}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                        },
                                                    },
                                                }}
                                            >
                                                {state.szekOptions.map((sz, index) => (
                                                    <MenuItem key={`${sz.id || 'szek'}-${index}`} value={sz.nev || sz.name}>{sz.nev || sz.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth disabled={!state.selectedSzek}>
                                            <InputLabel>{t('Map.Toolbox.kozseg', 'Község / Város')}</InputLabel>
                                            <Select
                                                value={state.selectedKozseg}
                                                label={t('Map.Toolbox.kozseg', 'Község / Város')}
                                                onChange={(e) => dispatch({ type: 'setSelectedKozseg', value: e.target.value })}
                                            >
                                                {state.kozsegOptions.map((k, index) => (
                                                    <MenuItem key={`${k.uniqueid || 'kozseg'}-${index}`} value={k.nev || k.name}>{k.nev || k.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth disabled={!state.selectedKozseg}>
                                            <InputLabel>{t('Map.Toolbox.telepules', 'Település')}</InputLabel>
                                            <Select
                                                value={state.selectedTelepules}
                                                label={t('Map.Toolbox.telepules', 'Település')}
                                                onChange={(e) => dispatch({ type: 'setSelectedTelepules', value: e.target.value })}
                                            >
                                                {state.telepulesOptions.map((t, index) => (
                                                    <MenuItem key={`${t.id || 'telepules'}-${index}`} value={state.isCsangoValue ? (t.id || t.uniqueid || t.pk) : (t.nev_hu || t.nev || t.name || String(t.id))}>{t.nev_hu || t.nev || t.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            )}

                            <Box sx={{ height: isMobile ? '300px' : '400px', width: '100%', position: 'relative' }}>
                                {category === 'foldtani' && (
                                    <Box sx={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}>
                                        <Tooltip title={t('Thematic.GetCurrentLocation', 'Jelenlegi pozíció lekérése')}>
                                            <IconButton 
                                                onClick={handleGetLocation}
                                                sx={{ 
                                                    bgcolor: 'white', 
                                                    '&:hover': { bgcolor: '#f5f5f5' },
                                                    boxShadow: 2
                                                }}
                                                color="primary"
                                            >
                                                <MyLocationIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                )}
                                <MapContainer 
                                    center={[state.latitudeValue, state.longitudeValue]} 
                                    zoom={13} 
                                    style={{ height: '100%', borderRadius: '8px' }}
                                >
                                    <TileLayer url={config[environment].osmTiles} />
                                    <TheMapComponent />
                                    <MapFlyTo location={[state.latitudeValue, state.longitudeValue]} />
                                    <Marker position={[state.latitudeValue, state.longitudeValue]} icon={defaultIcon} />
                                </MapContainer>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: 'stretch', gap: 2, mb: 2 }}>
                                <Button 
                                    variant={state.useExistingImage ? "outlined" : "contained"} 
                                    onClick={() => dispatch({ type: 'toggleUseExistingImage', value: false })}
                                    sx={{ flex: 1 }}
                                >
                                    {t('Thematic.UploadNew', 'Új képek feltöltése')}
                                </Button>
                                <Button 
                                    variant={state.useExistingImage ? "contained" : "outlined"} 
                                    onClick={() => dispatch({ type: 'toggleUseExistingImage', value: true })}
                                    disabled={state.availableImages.length === 0}
                                    sx={{ flex: 1 }}
                                >
                                    {t('Thematic.UseExisting', 'Létező kép használata')}
                                </Button>
                            </Box>
                        </Grid>

                        {!state.useExistingImage ? (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" gutterBottom>{t('Thematic.Thumbnail', 'Thumbnail kép')}</Typography>
                                    <Button variant="outlined" component="label" fullWidth sx={{ textTransform: 'none', py: 1 }}>
                                        <Typography variant="body2" noWrap sx={{ maxWidth: '100%' }}>
                                            {state.thumbnailFile ? state.thumbnailFile.name : t('Common.ChooseFile', 'Fájl kiválasztása')}
                                        </Typography>
                                        <input type="file" hidden accept="image/*" onChange={(e) => dispatch({ type: 'catchThumbnailChange', value: e.target.files[0] })} />
                                    </Button>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" gutterBottom>{t('Thematic.LargeImage', 'Nagy kép')}</Typography>
                                    <Button variant="outlined" component="label" fullWidth sx={{ textTransform: 'none', py: 1 }}>
                                        <Typography variant="body2" noWrap sx={{ maxWidth: '100%' }}>
                                            {state.imageFile ? state.imageFile.name : t('Common.ChooseFile', 'Fájl kiválasztása')}
                                        </Typography>
                                        <input type="file" hidden accept="image/*" onChange={(e) => dispatch({ type: 'catchImageChange', value: e.target.files[0] })} />
                                    </Button>
                                </Grid>
                            </>
                        ) : (
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>{t('Thematic.SelectImage', 'Válasszon képet')}</InputLabel>
                                    <Select
                                        value={state.selectedExistingImage}
                                        label={t('Thematic.SelectImage', 'Válasszon képet')}
                                        onChange={(e) => dispatch({ type: 'catchSelectedExistingImage', value: e.target.value })}
                                    >
                                        {state.availableImages.map((img) => (
                                            <MenuItem key={img} value={img}>{img}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
                                    {t('Thematic.ExistingImageNote', 'A kiválasztott kép lesz használva nagy képként és thumbnailként is.')}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>

                    {state.error && <Alert severity="error" sx={{ mt: 3 }}>{state.error}</Alert>}

                    <Box sx={{ mt: 4, display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 2 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            size="large"
                            disabled={state.disabledBtn}
                            sx={{ bgcolor: '#105b79', flex: isMobile ? 'none' : 1, order: isMobile ? 1 : 1 }}
                        >
                            {state.disabledBtn ? <CircularProgress size={24} color="inherit" /> : t('Common.Submit', 'Beküldés')}
                        </Button>
                        <Button 
                            variant="contained" 
                            color="error" 
                            size="large" 
                            onClick={() => setOpenDeleteDialog(true)}
                            sx={{ flex: isMobile ? 'none' : 1, order: isMobile ? 3 : 2 }}
                        >
                            {t('Common.Delete', 'Törlés')}
                        </Button>
                        <Button variant="outlined" size="large" onClick={() => navigate(-1)} sx={{ flex: isMobile ? 'none' : 1, order: isMobile ? 2 : 3 }}>
                            {t('Common.Cancel', 'Mégse')}
                        </Button>
                    </Box>
                </form>
            </Paper>

            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle>{t('Common.ConfirmDelete', 'Törlés megerősítése')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {t('Common.DeleteConfirmationMessage', 'Biztosan törölni szeretné ezt az elemet? Ez a művelet nem vonható vissza.')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)}>{t('Common.Cancel', 'Mégse')}</Button>
                    <Button onClick={handleDelete} color="error" autoFocus>{t('Common.Delete', 'Törlés')}</Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={state.openSnack} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert severity="success" sx={{ width: '100%' }}>
                    {t('Common.Success', 'Sikeres mentés!')}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default EditThematicPoint;
